/*
 * Module for the Insurance Carriers index view
 */

rs.module("fund/configuration/insurancecarriers/index",

    ["controls/data/grid"],

    function (gridModule) {
        function initialize(carrierGridProperties, jsSelectors, ajaxUrls) {            
            var carrierForm = $.js(jsSelectors.carrierForm);
            var carrierFilter = carrierForm.js(jsSelectors.carrierFilter);
            var currentVendorList = carrierFilter.js(jsSelectors.currentVendorList);
            var carrierLoadingSpinner = carrierFilter.js(jsSelectors.carrierLoadingSpinner);                   

            // Hook up click event on the radio buttons to reload the grid data via ajax
            currentVendorList.find("input").on('click', function () {
                carrierLoadingSpinner.show();

                // Update grid
                gridModule.update(
                    ajaxUrls.carrierGridData,

                    { currentOnly: currentVendorList.find("input:checked").val() },

                    carrierGridProperties.api,

                    function done() {
                        carrierLoadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
)
